module.exports = __webpack_public_path__ + "img/スバル.c0e4cced.png";